import { AppUrl } from "../../../../Helpers/AppUrl";
import { NavLink } from "react-router-dom";
export default function Error404() {

    return (
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <div className="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            404 Not Found</h2>
                        <div className="error-details">
                            Sorry, an error has occured, Requested page not found!
                        </div>
                        <div className="error-actions">
                            <NavLink replace to={AppUrl.Home} className="btn btn-primary btn-lg"><span className="glyphicon glyphicon-home"></span>
                                Take Me Home </NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
} 